import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { orangeMui } from "@ryde/theme";

export const BookingHubCellStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "booking-hub-cell",
})`
  width: 100%;

  min-width: 0;

  overflow: hidden;

  .booking-hub-cell {
    display: flex;

    align-items: center;

    gap: 4px;

    width: 100%;

    min-width: 0;
  }

  .hub-icon {
    width: 16px;

    height: 16px;

    flex-shrink: 0;
  }

  .booking-hub-cell__calculated-mark {
    flex-shrink: 0;

    color: #d32f2f;

    font-size: 13px;

    font-weight: 700;

    line-height: 1;
  }

  .booking-hub-cell__name {
    flex: 1 1 auto;

    min-width: 0;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
  }

  .booking-hub-cell__badge {
    flex-shrink: 0;

    font-size: 11px;

    line-height: 1;

    padding: 2px 6px;

    border-radius: 10px;

    text-transform: lowercase;
  }

  .booking-hub-cell__badge--stored {
    background: rgba(46, 125, 50, 0.12);

    color: #2e7d32;
  }

  .booking-hub-cell__badge--calculated {
    background: rgba(21, 101, 192, 0.12);

    color: #1565c0;
  }

  .booking-hub-cell__badge--skip {
    background: rgba(109, 109, 109, 0.12);

    color: #6d6d6d;
  }

  .booking-hub-cell__incomplete {
    display: inline-flex;

    flex-shrink: 0;

    align-items: center;
  }

  .booking-hub-cell__incomplete-icon {
    width: 14px;

    height: 14px;

    color: ${orangeMui._800};
  }
`;
